import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  // ToggleButtonReuse,
  ToggleButtonReuseTwo,
  ToggleButtonWithYesNo,
} from "../../AllButton/ToggleButtonReuse";
import { Button, Image } from "react-bootstrap";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";

export const FastFoodEditOffersManagement = (props) => {
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );
  let history = useHistory();
  const [state, setState] = useState({
    casualDiningOfflineOffers: false,
    casualDiningOnlineOffers: false,
    casualDiningOnlineOffersTotalPercentage: false,
    casualDiningOnlineOffersTotalAmount: false,
  });

  const casualDiningOfflineOffersHandler = (e) => {
    setState({
      ...state,
      casualDiningOfflineOffers: !state.casualDiningOfflineOffers,
    });
  };

  const casualDiningOnlineOffersHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffers: !state.casualDiningOnlineOffers,
    });
  };

  const casualDiningOnlineOffersTotalPercentageHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffersTotalPercentage:
        !state.casualDiningOnlineOffersTotalPercentage,
      casualDiningOnlineOffers: true,
    });
  };

  const casualDiningOnlineOffersTotalAmountHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffersTotalAmount:
        !state.casualDiningOnlineOffersTotalAmount,
      casualDiningOnlineOffers: true,
    });
  };

  useEffect(() => {
    setState({
      casualDiningOfflineOffers:
        props.subscriptionData && props.subscriptionData.offline_offer,
      casualDiningOnlineOffers:
        props.subscriptionData && props.subscriptionData.online_offer.value,
      casualDiningOnlineOffersTotalPercentage:
        props.subscriptionData &&
        props.subscriptionData.online_offer.percentage_total_order_value,
      casualDiningOnlineOffersTotalAmount:
        props.subscriptionData &&
        props.subscriptionData.online_offer.amount_toward_order_value,
    });
  }, [props.subscriptionData]);

  const onCasualOnlineOffersSubmitClick = (e) => {
    let values = {
      offline_offer: state.casualDiningOfflineOffers,
      online_offer: {
        value: state.casualDiningOnlineOffers,
        percentage_total_order_value:
          state.casualDiningOnlineOffersTotalPercentage,
        amount_toward_order_value: state.casualDiningOnlineOffersTotalAmount,
      },
      value: true,
      // value:
      //   state.casualDiningOfflineOffers || state.casualDiningOnlineOffers
      //     ? true
      //     : false,
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    formData.fast_food_dining_status.offer_management = values;
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Offers subscription added successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/profile");
  };

  const [editButton, setEditButton] = useState(false);
  const [editButtonTwo, setEditButtonTwo] = useState(false);
  const onEditClickChange = (e) => {
    setEditButton(!editButton);
  };
  const onEditClickChangeTwo = (e) => {
    setEditButtonTwo(!editButtonTwo);
  };

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-8 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className=" p-0">
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText="Offers Management"
                      displayEdit={editButton}
                      onClickEdit={onEditClickChange}
                    />
                  </div>
                  <div className="row">
                    <div className="col-10">
                      <ToggleButtonReuseTwo
                        mainText="Offline Offers"
                        paragraphText="(Note: these offers can be only be used in your business location offline)"
                        checkedBox={state.casualDiningOfflineOffers}
                        onChange={
                          editButton
                            ? casualDiningOfflineOffersHandler
                            : () => {}
                        }
                        disabled={editButton ? "" : true}
                        extraClass="d-flex align-items-center"
                      />
                    </div>
                    <div className="col-2">
                      {editButton ? (
                        ""
                      ) : (
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={(e) => onEditClickChange()}
                        >
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                      )}
                    </div>
                    <hr className="mt-5 mb-5" />
                    <div className="col-10">
                      <ToggleButtonReuseTwo
                        mainText="Online Offers"
                        paragraphText="(Note: these offers can be only be used in on application platform for Ordering and Booking)"
                        checkedBox={state.casualDiningOnlineOffers}
                        disabled={editButtonTwo ? "" : true}
                        onChange={
                          editButtonTwo ? casualDiningOnlineOffersHandler : ""
                        }
                        extraClass="d-flex align-items-center"
                      />
                      <div className="col-12 online-offline-offer-bottom-text">
                        <div className="my-3 f12-400">
                          Following Options are available at this time, we keep
                          adding new ways frequently, you can come back to To
                          enable them periodically and maintain information at
                          time of creation of online offers/deals/coupons On the
                          platform.
                        </div>
                        <div className="f11-400 opacity5">
                          You can maintain specifics at the time of Offer
                          creation for applicable services
                        </div>
                        <div className="mt-3 f14-700">
                          Description of available options :
                        </div>
                        <div className="row">
                          <div className="col-8">
                            <div className="f13-500 mt-3">
                              Percent of Total Order Value
                            </div>
                          </div>
                          <div className="col-4">
                            <ToggleButtonWithYesNo
                              activeClass={
                                state.casualDiningOnlineOffersTotalPercentage
                              }
                              checkedBox={
                                state.casualDiningOnlineOffersTotalPercentage
                              }
                              onChange={
                                editButtonTwo
                                  ? casualDiningOnlineOffersTotalPercentageHandler
                                  : ""
                              }
                              disabled={editButtonTwo ? "" : true}
                              extraClass="d-flex align-items-center"
                              extraYesNo="f12-500"
                            />
                          </div>
                          <div className="col-8">
                            <div className="f13-500 mt-3">
                              Amount towards Total Order Value
                            </div>
                          </div>
                          <div className="col-4">
                            <ToggleButtonWithYesNo
                              activeClass={
                                state.casualDiningOnlineOffersTotalAmount
                              }
                              checkedBox={
                                state.casualDiningOnlineOffersTotalAmount
                              }
                              onChange={
                                editButtonTwo
                                  ? casualDiningOnlineOffersTotalAmountHandler
                                  : ""
                              }
                              disabled={editButtonTwo ? "" : true}
                              extraClass="d-flex align-items-center"
                              extraYesNo="f12-500"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      {editButtonTwo ? (
                        ""
                      ) : (
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={(e) => onEditClickChangeTwo()}
                        >
                          <Image
                            src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                      )}
                    </div>
                  </div>

                  <div className="onboarding-map-setup-screen-autodetect-button mt-4">
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      buttonType="button"
                      onClick={(e) => history.push("/profile")}
                    />
                    {/* {!disabled &&
                      (editButton ? ( */}
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass={
                        // state.actionButton
                        //   ?
                        "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        // : "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                      }
                      buttonText="Done"
                      buttonType="button"
                      onClick={
                        // state.actionButton
                        //   ?
                        onCasualOnlineOffersSubmitClick
                        // : ""
                      }
                      // disabled={disabled}
                    />
                    {/* ) : (
                        ""
                      ))} */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="bottom-panel">
              <BottomNavigationMobile />
            </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
};

FastFoodEditOffersManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .offer_management,
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(FastFoodEditOffersManagement));
